'use strict';

angular.module('app.howToWatch', [])
.config([
  '$stateProvider', 'PRODUCT', 
  function($stateProvider, product) {

  	let logTemplate = 'components/howToWatch/howToWatchView.html';
	if (product.Code != 'htv') {
		logTemplate = 'assets/templates/' + product.Code + '/howToWatch/howToWatchView.html';
	}

    $stateProvider.state('app.howToWatch', {
      url: '/how-to-watch',
      templateUrl: logTemplate,
      title: 'How to Watch'
    });
  }
]);


// WEBPACK FOOTER //
// ./app.v2/components/howToWatch/howToWatch.js